import React, { useEffect } from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import AllMessages from "../AllMessages/AllMessages";
import Chat from "../Chat/Chat";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { Link, NavLink, useParams } from "react-router-dom";
import { useState } from "react";

const Messages = (props) => {
  const [toggleChat, setToggleChat] = useState(false);

  const routeParams = useParams();

  const flagFetchHandler = (flag) => {
    setToggleChat(flag);
  };
  
  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to="/">
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">Messages</p>
          <Row>
            <Col md="6">
              <AllMessages
                FlagFetchHandler={flagFetchHandler}
                selectedChannel={routeParams}
              />
            </Col>
            <Col md="6">
              <Chat ToggleChat={toggleChat} selectedChannel={routeParams} />
            </Col>
          </Row>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default Messages;
